import jQuery from 'jquery';
import React from 'react';
import { render } from 'react-dom';
import Root from './containers/Root';
import configureStore from './store/configureStore';
import * as mqBreakpoints from 'rp-mq-breakpoints';
import init from 'rp-gui-guide';
import popup from 'rp-popup';
import advertising from 'rp-advertising';
import initNavigationPrefs from 'rp-url-navigation-prefs';

import 'rp-gui-guide/dist/css/rpguiguide.min.css';
import 'rp-advertising/dist/rpadvertising.min.css';
import './styles/app.scss';

import { checkVersionChanges } from './utils/versionHelper';
import analyticsPage from './analyticsPage';

jQuery.cookie('to_force_inclusion_in_code');

analyticsPage();

checkVersionChanges();

init({
    svg: { polyfill: true },
});

const store = configureStore();

render(
    <Root store={store} />,
    document.getElementById('root')
);

popup();

advertising();
initNavigationPrefs();

window.rpBreakpoints = mqBreakpoints;



// WEBPACK FOOTER //
// ./src/client/index.js